<template>
  <v-card>
    <v-card-title>
      Dummy Releases
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rows"
      :search="search"
    >
      <template v-slot:item.releasedate="{ item }">
        <div>{{ item.releasedate | date }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil-outline</v-icon>
        <v-icon small color="red" @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      headers: [
        { text: 'Artist', sortable: false, value: 'name'},
        { text: 'Title', value: 'title' },
        { text: 'Media', value: 'media' },
        { text: 'Label', value: 'label' },
        { text: 'EAN-code', value: 'ean_code' },
        { text: 'Releasedate', value: 'releasedate' },
        { value: 'actions', sortable: false },
      ],
      rows: [
        {
          name: 'Frozen Yogurt',
          title: 'Cold, Cold Breakfast',
          media: 'CD',
          ean_code: 7310123456781,
          label: 'Slimy Records',
          releasedate: new Date(),
        },
        {
          name: 'Ice cream sandwich',
          title: 'Frozen teeth',
          media: 'CD',
          ean_code: 7310123456782,
          label: 'Cold Records',
          releasedate: new Date(),
        },
        {
          name: 'Eclair',
          title: 'Parle vouz?',
          media: 'CD',
          ean_code: 7310123456783,
          label: 'Big Lable Society',
          releasedate: new Date(),
        },
        {
          name: 'Cupcake',
          title: 'Pops',
          media: 'CD',
          ean_code: 7310123456784,
          label: 'Sweet Labels',
          releasedate: new Date(),
        },
        {
          name: 'Gingerbread',
          title: 'Without Santa, Goat and Pig',
          media: 'CD',
          ean_code: 7310123456785,
          label: 'Crunchy Records',
          releasedate: new Date(),
        },
        {
          name: 'Jelly bean',
          title: 'Toothache',
          media: 'DigiPack',
          ean_code: 7310123456786,
          label: 'Bag of Records',
          releasedate: new Date(),
        },
        {
          name: 'Lollipop',
          title: 'Mmmmmm',
          media: 'LP',
          ean_code: 7310123456787,
          label: 'Sweet Records',
          releasedate: new Date(),
        },
        {
          name: 'Honeycomb',
          title: 'Players',
          media: 'CD',
          ean_code: 7310123456788,
          label: 'Sweet Records',
          releasedate: new Date(),
        },
        {
          name: 'Donut',
          title: 'Pour some chocolate on me',
          media: 'CD',
          ean_code: 7310123456789,
          label: 'Chockfilled Records ',
          releasedate: new Date(),
        },
        {
          name: 'KitKat',
          title: 'Tearing down the wallpapers',
          media: 'CD',
          ean_code: 7310123456780,
          label: 'Meow Records',
          releasedate: new Date(),
        },
      ],
    }
  },

  methods: {
    editItem(item) {
      console.log(item.name)
    },
    async deleteItem(item) {
      const res = await this.$dialog.confirm({
        text: this.$t('app.delete-confirm'),
        title: this.$t('app.delete')
      })
      console.log(item.name,res)
    },
  }
}
</script>

<style>

</style>